<template>
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-form" ref="form" @submit.prevent="onSubmit($event)">
      <!--begin::Form-->
      <form class="kt-form">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-brand flaticon-home"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="kt-section kt-section--first">
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <div class="form-group">
                  <label class="label-required">รหัสบาร์โค้ด:</label>
                  <input
                    id="Barcode"
                    name="Barcode"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="รหัสบาร์โค้ด"
                    value="A000007"
                  />
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <div class="form-group">
                  <label class="label-required">รหัสทรัพย์สิน(บัญชี):</label>
                  <input
                    id="AssetAudit"
                    name="AssetAudit"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="รหัสทรัพย์สิน(บัญชี)"
                    value="ASAHI-30L 2015/01093"
                  />
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <div class="form-group">
                  <label class="label-required">รหัสทรัพย์สิน(เบียร์สด):</label>
                  <input
                    id="AssetOther"
                    name="AssetOther"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="รหัสทรัพย์สิน(เบียร์สด)"
                    value
                  />
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <div class="form-group">
                  <label>NFC:</label>
                  <input
                    id="NFC"
                    name="NFC"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="NFC"
                    value="0800000000"
                    readonly
                  />
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <div class="form-group">
                  <label>ประเภทสินค้า:</label>
                  <select
                    id="ProductType"
                    name="ProductType"
                    class="form-control m-select2"
                    style="width: 100%;"
                  >
                    <option value="1" selected>ถังเบียร์สด</option>
                  </select>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <div class="form-group">
                  <label class="label-required">ชื่อสินค้า:</label>
                  <select
                    id="ProductName"
                    name="ProductName"
                    class="form-control m-select2"
                    style="width: 100%;"
                  >
                    <option value="1" selected>Asahi Beer 30L</option>
                  </select>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <div class="form-group">
                  <label>วันที่เริ่มต้น:</label>
                  <datepicker
                    id="StartDate"
                    name="StartDate"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="วันที่เริ่มต้น"
                  />
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <div class="form-group">
                  <label>ระยะเวลาประกันถัง(วัน):</label>
                  <input
                    id="InsuranceDay"
                    name="InsuranceDay"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="ระยะเวลาประกันถัง(วัน)"
                    value="365"
                  />
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <div class="form-group">
                  <label>เจ้าของทรัพย์สิน:</label>
                  <input
                    id="Owner"
                    name="Owner"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="เจ้าของทรัพย์สิน"
                    value="โรงงานปทุมธานีฯ (คลังสินค้า)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="kt-portlet__foot">
          <button type="button" class="btn btn-secondary">
            <i class="la la-close"></i> ย้อนกลับ
          </button>
          <button type="submit" class="btn btn-primary">
            <i class="la la-save"></i> บันทึกข้อมูล
          </button>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import datepicker from "../../../Shared/Datepicker";
export default {
  components: { datepicker },
  data: function() {
    return {
      // userName: null,
      // password: null,
      // confirmPassword: null,
      // email: null,
      // givenName: null,
      // familyName: null,
      // position: null,
      // phoneNumber: null,
      // roleName: null
    };
  },
  methods: {
    formSubmit: function(e) {
      e.preventDefault();

      if (
        !$("#holdCreateModal form")
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      let router = this.$router;
      axios
        .post("/Api/Users/Create", {
          userName: this.userName,
          password: this.password,
          confirmPassword: this.confirmPassword,
          email: this.email,
          givenName: this.givenName,
          familyName: this.familyName,
          position: this.position,
          phoneNumber: this.phoneNumber,
          roleName: this.roleName,
        })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                $("#holdCreateModal").modal("hide");
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    $("#ProductType").select2({
      tags: true,
      placeholder: "กรุณาเลือก",
      allowClear: true,
    });
    $("#ProductName").select2({
      tags: true,
      placeholder: "กรุณาเลือก",
      allowClear: true,
    });

    // set validation rules
    $("#holdCreateModal form").validate({
      // rules: {
      //   userName: "required",
      //   email: {
      //     required: true,
      //     email: true
      //   },
      //   password: {
      //     required: true,
      //     minlength: 6
      //   },
      //   confirmPassword: {
      //     equalTo: "#password"
      //   },
      //   givenName: "required",
      //   familyName: "required",
      //   phoneNumber: "required"
      // },
      // messages: {
      //   userName: "กรุณากรอกชื่อผู้ใช้งาน (Username)",
      //   email: {
      //     required: "กรุณากรอกอีเมล",
      //     email: "กรุณากรอกอีเมลให้ถูกต้อง"
      //   },
      //   password: {
      //     required: "กรุณากรอกรหัสผ่าน",
      //     minlength: "รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร"
      //   },
      //   confirmPassword: {
      //     equalTo: "กรุณากรอกรหัสผ่านให้ตรงกันทั้ง 2 ช่อง"
      //   },
      //   givenName: "กรุณากรอกชื่อ",
      //   familyName: "กรุณากรอกชื่อสกุล",
      //   phoneNumber: "กรุณากรอกเบอร์โทรศัพท์"
      // }
    });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/Barcode/UpdateBarcode.vue